(function(){
  const moneyFormat = (cents) => '$' + (cents/100).toFixed(2);

  async function fetchCart(){
    const r = await fetch('/cart.js'); return r.json();
  }
  async function addToCart(id, qty){
    const r = await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id,quantity:qty||1})});
    return r.json();
  }
  async function changeLine(key, quantity){
    const r = await fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:key,quantity})});
    return r.json();
  }

  function renderCart(cart){
    const body = document.querySelector('[data-cart-body]');
    if(!body) return;
    if(!cart.items.length){
      body.innerHTML = '<p class="muted center" style="padding:48px 0">Your bag is empty.</p>';
      const f = document.querySelector('.cart-drawer__footer'); if(f) f.remove();
      return;
    }
    body.innerHTML = cart.items.map(i => `
      <div class="cart-line">
        <img src="${i.image}" alt="${i.product_title}">
        <div style="flex:1">
          <p class="cart-line__title">${i.product_title}</p>
          <p class="muted" style="font-size:12px;margin:4px 0">${moneyFormat(i.price)}</p>
          <div style="display:inline-flex;border:1px solid var(--border);margin-top:8px">
            <button data-qty="-1" data-key="${i.key}" style="padding:4px 10px">−</button>
            <span style="padding:4px 12px;font-size:12px">${i.quantity}</span>
            <button data-qty="1" data-key="${i.key}" style="padding:4px 10px">+</button>
          </div>
        </div>
        <p style="font-size:14px">${moneyFormat(i.line_price)}</p>
      </div>
    `).join('');

    let footer = document.querySelector('.cart-drawer__footer');
    if(!footer){
      footer = document.createElement('div');
      footer.className = 'cart-drawer__footer';
      document.querySelector('.cart-drawer__panel').appendChild(footer);
    }
    footer.innerHTML = `
      <div style="display:flex;justify-content:space-between;font-size:14px"><span class="eyebrow" style="margin:0">Subtotal</span><span>${moneyFormat(cart.total_price)}</span></div>
      <p class="muted" style="font-size:12px">Shipping and taxes calculated at checkout.</p>
      <a class="btn btn--primary btn--block" href="/checkout">Checkout</a>
    `;

    body.querySelectorAll('button[data-qty]').forEach(btn => {
      btn.addEventListener('click', async () => {
        const key = btn.dataset.key;
        const delta = parseInt(btn.dataset.qty,10);
        const cart = await fetchCart();
        const line = cart.items.find(x=>x.key===key);
        if(!line) return;
        const updated = await changeLine(key, Math.max(0, line.quantity+delta));
        renderCart(updated);
        updateCount(updated.item_count);
      });
    });
  }

  function updateCount(n){
    document.querySelectorAll('[data-cart-count]').forEach(el => {
      el.textContent = n;
      el.style.display = n>0 ? '' : 'none';
    });
  }

  function openDrawer(){
    document.getElementById('CartDrawer').classList.add('is-open');
    document.body.style.overflow='hidden';
  }
  function closeDrawer(){
    document.getElementById('CartDrawer').classList.remove('is-open');
    document.body.style.overflow='';
  }

  document.addEventListener('click', async (e) => {
    const openBtn = e.target.closest('[data-cart-open]');
    if(openBtn){ e.preventDefault(); const c = await fetchCart(); renderCart(c); openDrawer(); }
    if(e.target.closest('[data-cart-close]')) closeDrawer();

    const addBtn = e.target.closest('[data-add-to-cart]');
    if(addBtn){
      e.preventDefault();
      const id = addBtn.dataset.variantId;
      const form = addBtn.closest('form');
      const qty = form ? (form.querySelector('[name=quantity]')?.value || 1) : 1;
      try{
        await addToCart(id, parseInt(qty,10));
        const c = await fetchCart();
        renderCart(c); updateCount(c.item_count); openDrawer();
      }catch(err){ console.error(err); }
    }

    if(e.target.closest('[data-menu-open]')) document.getElementById('MobileMenu')?.classList.add('is-open');
    if(e.target.closest('[data-menu-close]')) document.getElementById('MobileMenu')?.classList.remove('is-open');
  });

  fetchCart().then(c => updateCount(c.item_count));
})();


/* Size chart interaction */
(function(){
  document.addEventListener('click', function(e){
    var pick = e.target.closest && e.target.closest('[data-size-pick]');
    if(pick){
      var chart = pick.closest('[data-size-chart]');
      var size = pick.dataset.sizePick;
      chart.querySelectorAll('[data-size-row]').forEach(function(r){r.removeAttribute('data-selected');});
      pick.closest('[data-size-row]').setAttribute('data-selected','true');
      var out = chart.querySelector('[data-size-selected]');
      var val = chart.querySelector('[data-size-selected-value]');
      if(out && val){ val.textContent = size; out.hidden = false; }
      var form = chart.closest('form') || document.querySelector('form[action*="/cart/add"]');
      if(form){
        var select = form.querySelector('select[name="id"], select.variant-select');
        if(select){
          for(var i=0;i<select.options.length;i++){
            var t = select.options[i].textContent;
            if(t.indexOf(size) !== -1){ select.value = select.options[i].value; select.dispatchEvent(new Event('change',{bubbles:true})); break; }
          }
        }
      }
      return;
    }
    var toggle = e.target.closest && e.target.closest('[data-size-toggle]');
    if(toggle){
      var chart = toggle.closest('[data-size-chart]');
      var collapsed = chart.getAttribute('data-collapsed') === 'true';
      chart.setAttribute('data-collapsed', collapsed ? 'false' : 'true');
      toggle.setAttribute('aria-expanded', collapsed ? 'true' : 'false');
      var lbl = toggle.querySelector('.size-chart__toggle-label');
      if(lbl) lbl.textContent = collapsed ? 'Hide chart' : 'Show chart';
    }
  });
})();

/* Product gallery slider */
(function(){
  function init(g){
    var track = g.querySelector('[data-pgallery-track]');
    var slides = g.querySelectorAll('[data-pgallery-slide]');
    var dots = g.querySelectorAll('[data-pgallery-dot]');
    var thumbs = g.querySelectorAll('[data-pgallery-thumb]');
    var prev = g.querySelector('[data-pgallery-prev]');
    var next = g.querySelector('[data-pgallery-next]');
    if(!track || !slides.length) return;

    function goTo(i){
      i = Math.max(0, Math.min(slides.length - 1, i));
      var slide = slides[i];
      track.scrollTo({left: slide.offsetLeft, behavior: 'smooth'});
      setActive(i);
    }
    function setActive(i){
      dots.forEach(function(d,di){ d.classList.toggle('is-active', di===i); });
      thumbs.forEach(function(t,ti){ t.classList.toggle('is-active', ti===i); });
    }
    function currentIndex(){
      var w = track.clientWidth;
      return Math.round(track.scrollLeft / w);
    }

    if(prev) prev.addEventListener('click', function(){ goTo(currentIndex() - 1); });
    if(next) next.addEventListener('click', function(){ goTo(currentIndex() + 1); });
    dots.forEach(function(d,i){ d.addEventListener('click', function(){ goTo(i); }); });
    thumbs.forEach(function(t,i){ t.addEventListener('click', function(){ goTo(i); }); });

    var t;
    track.addEventListener('scroll', function(){
      clearTimeout(t);
      t = setTimeout(function(){ setActive(currentIndex()); }, 80);
    });

    // keyboard
    g.tabIndex = 0;
    g.addEventListener('keydown', function(e){
      if(e.key==='ArrowLeft') goTo(currentIndex() - 1);
      if(e.key==='ArrowRight') goTo(currentIndex() + 1);
    });
  }
  document.querySelectorAll('[data-pgallery]').forEach(init);
})();


/* Size chart — custom measurements */
(function(){
  function setSelectedLabel(chart, txt){
    var out = chart.querySelector('[data-size-selected]');
    var val = chart.querySelector('[data-size-selected-value]');
    if(out && val){ val.textContent = txt; out.hidden = !txt; }
  }
  function clearPresetSelection(chart){
    chart.querySelectorAll('[data-size-row]').forEach(function(r){r.removeAttribute('data-selected');});
  }
  function disableCustomInputs(chart, disabled){
    chart.querySelectorAll('[data-size-custom-input]').forEach(function(i){
      i.disabled = !!disabled;
    });
  }

  document.addEventListener('click', function(e){
    var t = e.target.closest && e.target.closest('[data-size-custom-toggle]');
    if(!t) return;
    var box = t.closest('[data-size-custom]');
    var fields = box.querySelector('[data-size-custom-fields]');
    var open = box.getAttribute('data-open') === 'true';
    box.setAttribute('data-open', open ? 'false' : 'true');
    t.setAttribute('aria-expanded', open ? 'false' : 'true');
    fields.hidden = open;
    if(!open){
      // opening custom: clear preset row selection
      var chart = box.closest('[data-size-chart]');
      clearPresetSelection(chart);
      setSelectedLabel(chart, 'Custom measurements');
    } else {
      // closing custom: clear selected label if still custom
      var chart = box.closest('[data-size-chart]');
      var val = chart.querySelector('[data-size-selected-value]');
      if(val && val.textContent === 'Custom measurements') setSelectedLabel(chart, '');
    }
  });

  // When user starts typing in a custom field, mark custom mode active
  document.addEventListener('input', function(e){
    var i = e.target.closest && e.target.closest('[data-size-custom-input]');
    if(!i) return;
    var chart = i.closest('[data-size-chart]');
    clearPresetSelection(chart);
    var box = i.closest('[data-size-custom]');
    if(box && box.getAttribute('data-open') !== 'true'){
      box.setAttribute('data-open','true');
      var fields = box.querySelector('[data-size-custom-fields]');
      if(fields) fields.hidden = false;
    }
    setSelectedLabel(chart, 'Custom measurements');
    var err = chart.querySelector('[data-size-custom-error]');
    if(err){ err.hidden = true; err.textContent = ''; }
  });

  // When a preset row is picked, clear custom inputs so they don't get sent
  document.addEventListener('click', function(e){
    var pick = e.target.closest && e.target.closest('[data-size-pick]');
    if(!pick) return;
    var chart = pick.closest('[data-size-chart]');
    var box = chart.querySelector('[data-size-custom]');
    if(!box) return;
    box.setAttribute('data-open','false');
    var fields = box.querySelector('[data-size-custom-fields]');
    if(fields) fields.hidden = true;
    chart.querySelectorAll('[data-size-custom-input]').forEach(function(i){ i.value = ''; });
  });

  // Validate on add-to-cart submit
  document.addEventListener('submit', function(e){
    var form = e.target;
    if(!form.matches || !form.matches('form[action*="/cart/add"]')) return;
    var chart = form.querySelector('[data-size-chart]');
    if(!chart) return;
    var box = chart.querySelector('[data-size-custom]');
    if(!box || box.getAttribute('data-open') !== 'true') return;

    var inputs = box.querySelectorAll('[data-size-custom-input]');
    var values = {};
    var hasAny = false;
    inputs.forEach(function(i){
      var v = (i.value || '').trim();
      if(v) hasAny = true;
      values[i.dataset.sizeCustomInput] = v;
    });

    var err = chart.querySelector('[data-size-custom-error]');
    function fail(msg){
      if(err){ err.textContent = msg; err.hidden = false; }
      e.preventDefault();
    }

    if(!hasAny){
      return fail('Please enter at least one measurement, or pick a size from the chart.');
    }
    var nums = ['length','width','sleeve'];
    for(var k=0;k<nums.length;k++){
      var key = nums[k];
      var v = values[key];
      if(v){
        var n = parseFloat(v);
        if(isNaN(n) || n <= 0 || n > 100){
          return fail('Please enter a valid ' + key + ' between 1 and 100 inches.');
        }
      }
    }
    if((values.notes || '').length > 120){
      return fail('Notes must be under 120 characters.');
    }
  }, true);
})();
